// ─── RARITY ───────────────────────────────────────────────────
export const RARITY_ORDER = ["Common","Uncommon","Rare","Epic","Legendary","Mythic","Ultra"];

export const RARITY_HEX = {
  Common:    "#9e9e9e",
  Uncommon:  "#4caf50",
  Rare:      "#2196f3",
  Epic:      "#9c27b0",
  Legendary: "#ff9800",
  Mythic:    "#ffeb3b",
  Ultra:     "#ff2d78",
};

export const RARITY_RGB = {
  Common:    "158,158,158",
  Uncommon:  "76,175,80",
  Rare:      "33,150,243",
  Epic:      "156,39,176",
  Legendary: "255,152,0",
  Mythic:    "255,235,59",
  Ultra:     "255,45,120",
};

export const EPIC_RARITIES = ["Legendary","Mythic","Ultra"];

// ─── ECONOMY ──────────────────────────────────────────────────
export const ROLL_COST = 10;

export const COIN_VALUES = {
  Common: 3, Uncommon: 8, Rare: 20, Epic: 50,
  Legendary: 120, Mythic: 300, Ultra: 1000,
};

export const PITY_THRESHOLDS = { Rare: 50, Epic: 100, Legendary: 200 };

// ─── PRESTIGE ─────────────────────────────────────────────────
export const PRESTIGE_COLOURS = [
  "", "#00e5ff","#4caf50","#ff9800","#e91e63",
  "#9c27b0","#ffd700","#ff2d78",
];

// ─── MYSTERY BOX ──────────────────────────────────────────────
export const MYSTERY_BOX_OUTCOMES = [
  { weight:30, type:"coins",  value:50,   label:"🪙 50 coins!"              },
  { weight:25, type:"coins",  value:150,  label:"🪙 150 coins!"             },
  { weight:15, type:"coins",  value:300,  label:"🪙 300 coins!"             },
  { weight:10, type:"boost",  value:"lucky_charm",    label:"🍀 Lucky Charm!"   },
  { weight:8,  type:"boost",  value:"rare_surge",     label:"⚡ Rare Surge!"    },
  { weight:6,  type:"boost",  value:"hot_streak",     label:"🔥 Hot Streak!"    },
  { weight:4,  type:"boost",  value:"epic_guarantee", label:"💜 Epic Guarantee!" },
  { weight:2,  type:"coins",  value:1000, label:"🪙 JACKPOT! 1000 coins!"   },
];
